var map = {
	"./HK/mudou.svg": 58174,
	"./HK/mudou9.svg": 16615,
	"./HK/premiumVan.svg": 91823,
	"./HK/van.svg": 40603,
	"./SG/lorry10.svg": 51866,
	"./SG/lorry14.svg": 15788,
	"./SG/lorry24.svg": 50703,
	"./SG/motorcycle.svg": 26599,
	"./SG/sedan.svg": 69153,
	"./SG/van.svg": 88556,
	"./TW/motorcycle.svg": 92507,
	"./TW/mtruck.svg": 94076,
	"./TW/van.svg": 45466,
	"./VN/motorcycle.svg": 13755,
	"./VN/tricycle.svg": 95140,
	"./VN/truck1000.svg": 46410,
	"./VN/truck1500.svg": 18230,
	"./VN/truck2000.svg": 55104,
	"./VN/truck500.svg": 68892,
	"./VN/van1000.svg": 87068,
	"./VN/van500.svg": 33916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49804;